import type { ReactionType } from "@/lib/humhub-api/types";
import {
  createEmojiFallbackDataUri,
  REACTION_ASSETS,
} from "@/lib/utils/reactionAssets";

export const getReactionEmoji = (
  type: ReactionType | null,
  className = "h-4 w-4",
) => {
  const handleImageError = (
    e: React.SyntheticEvent<HTMLImageElement>,
    fallbackEmoji: string,
  ) => {
    e.currentTarget.src = createEmojiFallbackDataUri(fallbackEmoji);
  };

  if (type && type in REACTION_ASSETS) {
    const asset = REACTION_ASSETS[type];
    return (
      <img
        src={asset.src}
        alt={asset.alt}
        className={className}
        onError={(e) => handleImageError(e, asset.fallbackEmoji)}
      />
    );
  }

  return (
    <img
      src="/thumb-up.svg"
      alt="thumbs up"
      className={className}
      onError={(e) => handleImageError(e, "👍")}
    />
  );
};
